import { render, staticRenderFns } from "./NftIcon.vue?vue&type=template&id=c4aeef1a&scoped=true&"
import script from "./NftIcon.vue?vue&type=script&lang=ts&"
export * from "./NftIcon.vue?vue&type=script&lang=ts&"
import style0 from "./NftIcon.vue?vue&type=style&index=0&id=c4aeef1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aeef1a",
  null
  
)

export default component.exports